import { render, staticRenderFns } from "./allActive.vue?vue&type=template&id=76851165&scoped=true&"
import script from "./allActive.vue?vue&type=script&lang=js&"
export * from "./allActive.vue?vue&type=script&lang=js&"
import style0 from "./allActive.vue?vue&type=style&index=0&lang=css&"
import style1 from "./allActive.vue?vue&type=style&index=1&id=76851165&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76851165",
  null
  
)

export default component.exports